module.exports = __webpack_public_path__ + "img/xhd.04eeb047.png";